import Vue from 'vue'
import Router from 'vue-router'
import routerConfig from './routerConfig'

Vue.use(Router)




const router = new Router({
  mode: 'history',
  base: routerConfig.baseUrl,
  routes: [
    ...routerConfig.router
  ]
});

// 路由变化时
router.beforeEach((to, from, next) => {    
  if (document.title !== to.meta.title) {        
      document.title = to.meta.title;    
  }    
  next();
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js